const pagecontent = {
  //     DBServer: "http://192.168.102.157:3008",
  //Geoserver:"http://192.168.102.157:9001/geoserver"  ,
  //  DBServer: "https://bhuvan-staging1.nrsc.gov.in/nhpds",

  //   Geoserver:"https://bhuvan-staging1.nrsc.gov.in/bhuvan",
  title: "About",

  bodycontent:
    "<p>Under NHP, NRSC has taken up a research study titled -<font color='blue'>\"Satellite data based inputs for Irrigation Scheduling for a selected Irrigation Project Command Area \"</font>. Under this study, it is proposed to develop a Decision Support System (DSS) for irrigation water management. The DSS is expected to support efficient irrigation water management through generation of periodic advisories on actual irrigation demand at canal level based on near real time satellite data derived inputs.</p><p>The portal will essential display the geospatial database of the Narayanpur irrigation system which comprises of command area map, canal network, historical crop maps, etc. The in-season crop maps and canal wise irrigation deliveries will be updated through the respective season in the portal.</p>",

  //DBServer: "https://bhuvan-staging1.nrsc.gov.in/nhpds",

  //Geoserver:"https://bhuvan-staging1.nrsc.gov.in/bhuvannhp",

  link: "/webgis-irrigation/map",
};
export default pagecontent;
